import React, { useEffect, useState } from "react";
import moment from "moment";
import { fetchJson, post } from "../../lib/Fetching";
import TestQueryParametersForm from "./TestQueryParametersForm";
import Button from "../Button";

export default function NewResultNotificationGroup({ company_id, clientView }) {
  const [show, setShow] = useState(false);
  const [group, setGroup] = useState({
    name: "",
    include_failed_results: true,
    include_warning_results: false,
    include_detected_results: false,
    testing_category_ids: [],
    technique_ids: [],
    matrix_ids: [],
    product_ids: [],
    qualifier_ids: [],
  });

  const handleGroupSubmit = (group) =>
    post("/result_notifications/test_query_parameters", group)
      .then((json) => {
        window.location = "/result_notifications/test_query_parameters/" + json.result.id;
      })
      .catch((error) => alert(error));

  const toggle = () => setShow(!show);

  return (
    <div>
      <Button icon="fa-plus" title="Add Test Query Parameters" onClick={toggle} />
      {show && (
        <TestQueryParametersForm
          newGroup={group}
          handleGroupSubmit={handleGroupSubmit}
          clientView={clientView}
        />
      )}
    </div>
  );
}
